<template>
  <div class="wrap">
    <div class="banner">
      <img src="@/assets/image/exportbanner.png" style="width: 100%" alt=""/>
    </div>
    <div class="pagew">
      <!-- <Header activeIndex="/Work"/> -->
      <!-- <div class="select">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1">全部</el-menu-item>
          <el-menu-item index="2">主赛道</el-menu-item>
          <el-menu-item index="3">港澳台创新设计对接赛</el-menu-item>
          <el-menu-item index="4">企业命题设计专项赛</el-menu-item>
        </el-menu>
      </div> -->

      <div class="imgbox">
        <div class="box">
          <div
            class="boxitem"
            v-for="(item, index) in imgList"
            :key="index"
            @click="toPage(item, index)"
          >
            <div class="onde">
              <div class="top">
                <img
                  :src="`http://admin.gdsme.org/prod-api${item.workPhoto}`"
                  alt=""
                  style="width: 100%; margin-top: 20px"
                />
                <div class="ditu">{{ item.workDesigner }}</div>
              </div>
              <div class="cont">
                <div class="title" style="padding-top: 20px">
                  {{ item.workTitle }}
                </div>
                <div style="padding-top: 20px">
                  <template v-if="item.workGroup==1">产品设计组</template>
                  <template v-else-if="item.workGroup==2">创新企业组</template>
                  <template v-else-if="item.workGroup==3">概念设计组</template>
                  <template v-else-if="item.workGroup==4">港澳台赛</template>
                  <template v-else>其他</template>
                  -
                  <template v-if="item.workPrize==1">金奖</template>
                  <template v-else-if="item.workPrize==2">银奖</template>
                  <template v-else-if="item.workPrize==3">铜奖</template>
                  <template v-else-if="item.workPrize==4">优秀奖</template>
                  <template v-else>入围奖</template></div>
              </div>
              <!--  底部   -->
              <div class="bottom">
                <div class="photo">
                  <img src="@/assets/workimg/GLOD.png" alt=""/>
                </div>
                <div class="info" style="color: red; font-size: 12px">
                  READ MORE
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <Footer :show="false"/>
  </div>
</template>

<script>
import { getWorkList,getWorkYearList } from '@/api/api.js';
export default {
  name: "index",
  data() {
    return {
      imgList: [
        // {
        //   url: require("@/assets/workimg/work1.png"),
        //   workDesigner: "杨振天",
        //   workTitle: "SAFE OFF - PPE脱卸交互系统",
        //   workGroup: "创新概念组",
        //   workPrize:"金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work2.png"),
        //   name: "东莞小豚智能技术有限公司",
        //   title: "POWER+DIVING智能潜水动力背包",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work3.png"),
        //   name: "维沃移动通信",
        //   title: "VIVOAPEX2020",
        //   type: "创新概念组-银牌",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work4.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work5.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work6.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work7.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work8.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work9.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work10.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work11.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
        // {
        //   url: require("@/assets/workimg/work12.png"),
        //   name: "杨振天",
        //   title: "SAFE OFF - PPE脱卸交互系统",
        //   type: "创新概念组-金奖",
        //   show: false,
        // },
      ],
      url: "/Work",
      pageSize: 100,
      currentPage: 1,
      total: 0,
      activeIndex: "1",
      paramsYear:{
        workCompetition:this.$route.query.key
      }
    };
  },
  created() {
    // this.getList();
    this.getWorkYearList(this.paramsYear);
  },
  methods: {
    getList() {
      getWorkList({

      }).then(res => {
        // this.imgList = res.data || [];
        console.log(res);
      });
    },
    getWorkYearList(paramsYear){
      getWorkYearList(paramsYear).then(res => {
        this.imgList = res.data.rows || [];

        console.log(res);
      });
    },
    handleSelect(index){
      console.log(index);
      this.getList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    toPage(item, index) {
      this.$router.push({
        path: "Work/wordDetail",
        query: {
          id: index,
          title: item.workTitle,
          info:item
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.select {
  height: 80px;
  width: 60%;
  margin: 0 auto;
}
.el-menu-item.is-active {
  border-bottom: 2px solid red !important;
  color: red !important;
  font-weight: bold;
}

.el-menu-item {
  padding: 0 43px;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.wrap {
  text-align: left;
  width: 100%;

  .banner {
    width: 100%;
    z-index: -2;
    margin-bottom: 40px;
  }

  .imgbox {
    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .boxitem {
        width: 25%;
        padding-bottom: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .onde {
          width: 90%;
          height: 320px;

          .top {
            position: relative;

            .ditu {
              width: 100%;
              height: 45px;
              line-height: 45px;
              text-align: center;
              top: 175px;
              color: #ffffff;
              font-size: 14px;
              position: absolute;
              background: url("../../assets/workimg/ditu.png") no-repeat;
              background-position: center;
            }
          }

          .cont {
            font-size: 14px;
            text-align: center;
            background-color: #f5f5f5;
            padding: 20px 0;
          }

          .bottom {
            width: 100%;
            background-color: #f5f5f5;
            padding: 10px 0;
            display: flex;
            font-size: 14px;
            justify-content: space-around;
            align-items: center;

            div {
              // width: 50%;
              text-align: right;
              // padding-right: 10px;
            }
          }
        }
      }

      .boxitem:hover {
        // border-bottom: 1px solid red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Work/list.vue